import fulfill from '../../../fulfill';
import { SideEffectFunction } from '../../../sideEffects';
import { CORE_API_HOSTNAME } from '../../../env';
import { ActionTypes, FetchAccountResponse, GetAccount } from './actions';
import { Account } from '../../../types/management-auth';
import { ActionTypes as VippsActionTypes, FetchInitiateVippsConnectionResponse } from '../vipps/actions';
import {
    ActionTypes as VippsCallbackActionTypes,
    FetchCompleteVippsConnectionResponse
} from '../vippsCallback/actions';
import { ActionTypes as InstabankActionTypes, FetchInitiateInstabankConnectionResponse } from '../instabank/actions';
import { ActionTypes as PayExActionTypes, FetchInitiatePayExConnectionResponse } from '../payex/actions';
import { ActionTypes as SwishActionTypes, FetchInitiateSwishConnectionResponse } from '../swish/actions';
import {
    ActionTypes as SwishCallbackActionTypes,
    FetchCompleteSwishConnectionResponse
} from '../swishCallback/actions';
import {
    ActionTypes as PayExCallbackActionTypes,
    FetchCompletePayExConnectionResponse
} from '../payexCallback/actions';

const fetchAccount: SideEffectFunction<GetAccount, FetchAccountResponse> = async (action) => {
    const result: FetchAccountResponse = await fulfill.get({
        accountId: action.payload.accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${action.payload.accountId}/management/settings`,
        handlers: {
            200: (account: Account) => ({
                type: ActionTypes.FetchAccountResponse,
                payload: {
                    account,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const refetchAccount: SideEffectFunction<
    | FetchInitiateVippsConnectionResponse
    | FetchCompleteVippsConnectionResponse
    | FetchInitiateInstabankConnectionResponse
    | FetchInitiatePayExConnectionResponse
    | FetchCompletePayExConnectionResponse
    | FetchInitiateSwishConnectionResponse
    | FetchCompleteSwishConnectionResponse,
    FetchAccountResponse
> = async (action) => {
    const accountId = action.meta.cause.payload.accountId;
    const result: FetchAccountResponse = await fulfill.get({
        accountId: accountId,
        url: `${CORE_API_HOSTNAME}/v1/accounts/${accountId}/management/settings`,
        handlers: {
            200: (account: Account) => ({
                type: ActionTypes.FetchAccountResponse,
                payload: {
                    account,
                },
                meta: {
                    cause: action,
                },
            }),
        },
    });
    return result;
};

const effects = {
    [ActionTypes.GetAccount]: fetchAccount,
    [VippsActionTypes.FetchInitiateVippsConnectionResponse]: refetchAccount,
    [VippsActionTypes.UpdateVippsConnectionResponse]: refetchAccount,
    [InstabankActionTypes.FetchInitiateInstabankConnectionResponse]: refetchAccount,
    [PayExActionTypes.FetchInitiatePayExConnectionResponse]: refetchAccount,
    [PayExCallbackActionTypes.FetchCompletePayExConnectionResponse]: refetchAccount,
    [VippsCallbackActionTypes.FetchCompleteVippsConnectionResponse]: refetchAccount,
    [SwishActionTypes.FetchInitiateSwishConnectionResponse]: refetchAccount,
    [SwishCallbackActionTypes.FetchCompleteSwishConnectionResponse]: refetchAccount,
};

export default effects;
